import styled from 'styled-components';

export const Image = styled.img`
  object-fit: cover;
  border: 2px solid #cfcfcf;
  box-sizing: border-box;
  max-width: 100%;
  height: auto;
`;
